module.exports = __webpack_public_path__ + "img/example_print_step3.d63ea34e.png";